import Reveal from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const CASES = [
  {
    img: "https://images.pexels.com/photos/40371850/pexels-photo-40371850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    sector: "Deporte y fitness",
    title: "Centros deportivos en Levante",
    desc: "Venta de centros deportivos locales de la zona de Levante a un grupo internacional de gimnasios.",
    alt: "Interior de un centro deportivo moderno",
  },
  {
    img: "https://images.pexels.com/photos/35425761/pexels-photo-35425761.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    sector: "Tratamiento de aguas",
    title: "Empresa de tratamiento de aguas",
    desc: "Venta de una empresa de tratamiento de aguas de la zona Centro de España.",
    alt: "Planta de tratamiento de aguas vista aérea",
  },
  {
    img: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHx0cnVjayUyMGZsZWV0JTIwZGVhbGVyc2hpcCUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3OTI1ODA5OTZ8MA&ixlib=rb-4.1.0&q=85",
    sector: "Automoción",
    title: "Compraventa de camiones",
    desc: "Venta de una empresa de compraventa de camiones a un grupo multinacional.",
    alt: "Flota de camiones aparcados",
  },
  {
    img: "https://images.pexels.com/photos/36397860/pexels-photo-36397860.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    sector: "Reciclaje y medio ambiente",
    title: "Centros de reciclaje",
    desc: "Venta de centros de reciclaje de la zona de Levante y Castilla-La Mancha.",
    alt: "Grúa clasificando materiales en una planta de reciclaje",
  },
  {
    img: "https://images.pexels.com/photos/7433824/pexels-photo-7433824.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    sector: "Servicios profesionales",
    title: "Despachos fiscales y mercantiles",
    desc: "Venta de despachos profesionales especializados en Fiscalidad y Mercantil junto a SuperContable.",
    alt: "Reunión de estrategia en una asesoría profesional",
  },
];

export default function Cases() {
  return (
    <section id="casos" data-testid="cases-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid gap-10 md:grid-cols-12 md:items-end">
          <Reveal className="md:col-span-8">
            <p className="eyebrow">Casos de éxito</p>
            <h2 className="mt-6 font-serif text-4xl leading-tight text-white sm:text-5xl">
              Conoce algunos de nuestros mandatos cerrados.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-4">
            <a
              href="#contacto"
              data-testid="cases-cta"
              onClick={(e) => {
                e.preventDefault();
                scrollToId("#contacto");
              }}
              className="group inline-flex items-center gap-3 text-[13px] font-semibold uppercase tracking-[0.18em] text-gold transition-colors hover:text-gold-light md:float-right"
            >
              Consulta tu caso
              <span className="h-px w-10 bg-gold transition-all duration-300 group-hover:w-16" />
            </a>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-10 md:grid-cols-3 md:gap-8">
          {CASES.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1} testid={`case-card-${i + 1}`}>
              <article className="group relative">
                <div className="pointer-events-none absolute -left-2 -top-2 z-10 h-6 w-6 border-l border-t border-gold" />
                <div className="pointer-events-none absolute -bottom-2 -right-2 z-10 h-6 w-6 border-b border-r border-gold" />
                <span
                  data-testid={`case-confidencial-${i + 1}`}
                  className="absolute right-4 top-4 z-10 bg-ink/85 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold backdrop-blur-sm"
                >
                  Confidencial
                </span>
                <div className="relative overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.alt}
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    data-testid={`case-image-${i + 1}`}
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
                </div>
                <div className="border-b border-gold/15 pb-6 pt-6">
                  <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">{c.sector}</span>
                  <h3 className="mt-3 font-serif text-2xl text-white">{c.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300">{c.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
